import { QueryResult, useQuery } from '@apollo/client'

import { EMPLOYEE_LEVELS_BY_COUNTRY } from '../Queries'
import { Country, EmployeeLevelsByCountryQuery, EmployeeLevelsByCountryQueryVariables } from '../../../types'

export const useEmployeeLevelsByCountry = (
  country: Country,
): QueryResult<EmployeeLevelsByCountryQuery, EmployeeLevelsByCountryQueryVariables> => {
  return useQuery<EmployeeLevelsByCountryQuery, EmployeeLevelsByCountryQueryVariables>(EMPLOYEE_LEVELS_BY_COUNTRY, {
    variables: { country },
  })
}
